// src/components/services/FinoDomestic.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
    MdOutlineSendToMobile, MdOutlineAccountBalance, MdOutlineDescription,
    MdOutlineVerifiedUser, MdOutlineSecurity
} from 'react-icons/md';
import {
    FaPhoneAlt, FaMoneyCheckAlt, FaHandHoldingUsd,
    FaUserShield, FaClock
} from 'react-icons/fa';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
        staggerChildren: 0.2, // Stagger animation of child elements
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
};


function FinoDomestic() {
  const serviceName = "Fino Domestic Money Transfer";

    return (
        <section className="py-16 md:py-24 px-4 md:px-8 bg-gray-50 text-gray-700">

            <div className="container mx-auto">
                <motion.div
                initial="hidden"
                animate="visible"
                variants={containerVariants}
                >
                <motion.h1
                    variants={itemVariants}
                    className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 md:mb-8 text-center"
                >
                    Fino Domestic Money Transfer
                </motion.h1>
                <motion.p
                    variants={itemVariants}
                    className="text-lg md:text-xl text-gray-600 mb-10 md:mb-12 text-center max-w-3xl mx-auto"
                >
                    Transfer money instantly and securely within India through Keziah
                    Global Private Limited, in partnership with Fino Payments Bank. Our
                    Domestic Money Transfer service offers a fast, reliable, and
                    convenient way to send money to your loved ones or business
                    associates anywhere in the country.
                </motion.p>

                {/* Features and Benefits */}
                <motion.div
                    variants={itemVariants}
                    className="mb-12 md:mb-16 bg-white rounded-xl shadow-md p-6 md:p-10"
                >
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
                    Key Features
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {/* Feature 1 */}
                    <motion.div
                        className="flex items-start space-x-4"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className="p-3 rounded-full bg-blue-100">
                        <MdOutlineSendToMobile className="text-blue-600 text-2xl" />
                        </div>
                        <div>
                        <h4 className="font-bold text-gray-800 text-lg">
                            Instant Transfers
                        </h4>
                        <p className="text-gray-600">
                            Send money instantly to any bank account in India, 24/7.
                        </p>
                        </div>
                    </motion.div>
                    {/* Feature 2 */}
                    <motion.div
                        className="flex items-start space-x-4"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.1 }}
                    >
                        <div className="p-3 rounded-full bg-blue-100">
                        <MdOutlineAccountBalance className="text-blue-600 text-2xl" />
                        </div>
                        <div>
                        <h4 className="font-bold text-gray-800 text-lg">
                            Wide Network
                        </h4>
                        <p className="text-gray-600">
                            Transfer funds to any bank and any branch across India.
                        </p>
                        </div>
                    </motion.div>
                    {/* Feature 3 */}
                    <motion.div
                        className="flex items-start space-x-4"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.2 }}
                    >
                        <div className="p-3 rounded-full bg-blue-100">
                        <FaMoneyCheckAlt className="text-blue-600 text-2xl" />
                        </div>
                        <div>
                        <h4 className="font-bold text-gray-800 text-lg">
                            Low Transaction Fees
                        </h4>
                        <p className="text-gray-600">
                            Enjoy affordable transaction fees on your money transfers.
                        </p>
                        </div>
                    </motion.div>
                    {/* Feature 4 */}
                    <motion.div
                        className="flex items-start space-x-4"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.3 }}
                    >
                        <div className="p-3 rounded-full bg-blue-100">
                        <MdOutlineDescription className="text-blue-600 text-2xl" />
                        </div>
                        <div>
                        <h4 className="font-bold text-gray-800 text-lg">
                            Simple and Easy Process
                        </h4>
                        <p className="text-gray-600">
                            Transfer money with just a few simple steps at our branch or
                            through our authorized agents.
                        </p>
                        </div>
                    </motion.div>
                    {/* Feature 5 */}
                    <motion.div
                        className="flex items-start space-x-4"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.4 }}
                    >
                        <div className="p-3 rounded-full bg-blue-100">
                        <MdOutlineVerifiedUser className="text-blue-600 text-2xl" />
                        </div>
                        <div>
                        <h4 className="font-bold text-gray-800 text-lg">
                            Instant Confirmation
                        </h4>
                        <p className="text-gray-600">
                            Receive instant confirmation of your transaction via SMS and
                            email.
                        </p>
                        </div>
                    </motion.div>
                    {/* Feature 6 */}
                    <motion.div
                        className="flex items-start space-x-4"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.5 }}
                    >
                        <div className="p-3 rounded-full bg-blue-100">
                        <MdOutlineSecurity className="text-blue-600 text-2xl" />
                        </div>
                        <div>
                        <h4 className="font-bold text-gray-800 text-lg">
                            Secure and Reliable
                        </h4>
                        <p className="text-gray-600">
                            Your transactions are safe with our secure platform, backed
                            by Fino Payments Bank's advanced technology.
                        </p>
                        </div>
                    </motion.div>
                    </div>
                </motion.div>

                {/* How to Transfer Money */}
                <motion.div
                    variants={itemVariants}
                    className="mb-12 md:mb-16 bg-white rounded-xl shadow-md p-6 md:p-10"
                >
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
                    How to Transfer Money
                    </h3>
                    <ol className="list-decimal pl-8 space-y-4 text-gray-600 text-lg">
                    <li>Visit our branch in Salem, Tamil Nadu.</li>
                    <li>Provide the recipient's bank account details (account number, IFSC code, bank name, branch name).</li>
                    <li>Specify the amount you want to transfer.</li>
                    <li>
                    Complete the transaction securely and receive instant confirmation.
                    </li>
                    </ol>
                </motion.div>

                {/* Call to Action */}
                <motion.div
                    variants={itemVariants}
                    className="mb-12 md:mb-16 bg-white rounded-xl shadow-md p-6 md:p-10"
                >
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
                        Send Money Within India Today!
                    </h3>
                    <p className="text-gray-600 text-lg text-center">
                    Visit our branch in Salem, Tamil Nadu, for fast, secure, and affordable domestic money transfers. Our team is ready to assist you with your transaction. You can also request a callback to learn more about our services.
                    </p>
                    <motion.div
                        variants={itemVariants}
                        className="mt-10 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6"
                    >
                        <a
                        href="tel:9043588446"
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full text-base md:text-lg transition duration-300 ease-in-out shadow-md hover:shadow-lg text-center w-full md:w-auto flex items-center justify-center"
                        whileHover={{ scale: 1.05 }}
                        >
                        <FaPhoneAlt className="inline-block mr-2" />
                        Call Now
                        </a>
                        {/* Use Link for navigation */}
                        <Link to={`/callback?serviceName=${encodeURIComponent(serviceName)}`}>
                            <button

                                className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-3 px-6 rounded-full text-base md:text-lg transition duration-300 ease-in-out shadow-md hover:shadow-lg text-center w-full md:w-auto flex items-center justify-center"
                                whileHover={{ scale: 1.05 }}
                            >
                                Request a Callback
                            </button>
                        </Link>
                    </motion.div>
                </motion.div>
            </motion.div>
        </div>
    </section>
    );
}

export default FinoDomestic;